import { Controller } from "@ui/components/Form";
import { InputIcon, TextInput } from "@ui/components/Inputs";
import classNames from "classnames";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import type { ButtonProps, ButtonVariant } from "@jti/core-components/components/Button";
import { Button } from "@jti/core-components/components/Button";

import styles from "./LoyaltyReferralCodeForm.module.scss";

type LoyaltyReferralCodeFormProps = {
  isSuccess: boolean;
  disabled: boolean;
  error: string | null;
  requiredText: string;
  label: string;
  placeholder: string;
  helperText: string;
  successText: string;
  btnLabel: string;
  btnVariant?: ButtonVariant;
  inputContainerClassname?: string;
  contentWrapperClassname?: string;
  buttonSize?: ButtonProps["size"];
};

export const LoyaltyReferralCodeForm = ({
  isSuccess,
  disabled,
  error,
  requiredText,
  label,
  placeholder,
  helperText,
  successText,
  btnLabel,
  btnVariant = "secondary",
  inputContainerClassname = "",
  contentWrapperClassname = "",
  buttonSize,
}: LoyaltyReferralCodeFormProps) => {
  return (
    <div className={classNames(styles.contentWrapper, contentWrapperClassname)}>
      <Controller
        name="code"
        rules={{
          required: requiredText,
        }}
        render={({ field }) => (
          <TextInput
            {...field}
            containerClassName={classNames(styles.inputContainer, inputContainerClassname)}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            successText={successText}
            isSuccess={isSuccess}
            readOnly={isSuccess}
            elemAfter={isSuccess ? <InputIcon icon={UiCheckIcon} isSuccess isDisabled /> : undefined}
            errorText={error ?? undefined}
            isError={Boolean(error)}
          />
        )}
      />
      <Button size={buttonSize} className={styles.submitBtn} type="submit" variant={btnVariant} disabled={disabled}>
        {btnLabel}
      </Button>
    </div>
  );
};
